import { categories } from '@/mocks/data';
import { useNavigate } from 'react-router-dom';

export default function CategoryBrowsing() {
  const navigate = useNavigate();
  const displayCategories = categories.slice(1, 7);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">分类浏览</h2>
          <p className="text-sm text-foreground-500 mt-1">按类型找到你喜欢的漫画</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {displayCategories.map((cat) => (
            <div
              key={cat.id}
              className="flex flex-col items-center gap-3 p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer group"
              onClick={() => navigate(`/category?tab=${cat.id}`)}
            >
              <span className="w-12 h-12 rounded-full bg-primary-100 text-primary-500 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}